import { useCallback, useEffect } from 'react';

import { FinancialConfig } from '@futrli-sdk/predict';
import { useLoadDataRequest } from '@futrli/shared-services';

import { fetchLineData } from '../../../../core/api/financial-config';

type RequestDataType = Awaited<ReturnType<typeof fetchLineData>>;

/**
 * Loads the line data for the given forecast ID
 * @param workspaceId - Workspace ID for the organisation
 * @param organisationId - Organisation ID
 * @param forecastId - Forecast ID
 * @param financialConfig - Financial config for the given organisation
 */
export const useLoadLineData = (
  workspaceId: string,
  organisationId: string,
  forecastId: string | undefined,
  financialConfig: FinancialConfig | undefined
) => {
  const hasAllParams = !!workspaceId && !!organisationId && !!forecastId && !!financialConfig;
  const { load, ...rest } = useLoadDataRequest<RequestDataType>();

  const reload = useCallback(async () => {
    if (hasAllParams) {
      load(fetchLineData(workspaceId, organisationId, forecastId));
    }
  }, [forecastId, hasAllParams, load, organisationId, workspaceId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    hasAllParams,
    reload,
    ...rest
  };
};
